import { FormControlLabel, Switch, Card, Modal } from '@mui/material'
import SoftBox from 'components/SoftBox';
import React, { useEffect, useMemo, useState } from 'react'
import Grid from "@mui/material/Grid";
import SoftButton from 'components/SoftButton';
import SoftTypography from 'components/SoftTypography';
import MDModal from 'components/MDModal';
import SoftModal from 'components/SoftModal'
import FormField from 'components/FormField';
import { useQuery, useQueryClient } from "@tanstack/react-query";
import useRequest from "hook/useRequest";
import { ReqMethods } from "enums";
import { useUpdateAgency } from "queries/agency";
import {
  useCategoryPricing,
  useCreateCategoryPricing,
  useEditCategoryPricing,
  useDeleteCategoryPricing,
  useSubscriptionSetting,
} from "queries/saas";
import SoftSelect from "components/SoftSelect";
import ReactSelect from 'react-select';
import { useAgencyInfo } from 'context/agency';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import Select from "react-select";


const { GET } = ReqMethods;

function SettingTab() {
  const [agency, Update] = useAgencyInfo();

  const [sub_accounts_subscription_fail, setsub_accounts_subscription_fail] = useState(
    agency?.subscription_setting?.sub_accounts_subscription_fail || false
  );
  const [sub_accounts_admin_upgrade_subscription, setsub_accounts_admin_upgrade_subscription] = useState(
    agency?.subscription_setting?.sub_accounts_admin_upgrade_subscription || false
  );
  const [sub_accounts_admin_cancel_subscription, setsub_accounts_admin_cancel_subscription] = useState(
    agency?.subscription_setting?.sub_accounts_admin_cancel_subscription || false
  );

  const [toggleChecked, setToggleChecked] = useState(sub_accounts_subscription_fail);
  const [toggleChecked1, setToggleChecked1] = useState(sub_accounts_admin_upgrade_subscription);
  const [toggleChecked2, setToggleChecked2] = useState(sub_accounts_admin_cancel_subscription);

  const request = useRequest();
  const queryClient = useQueryClient();

  const currencies = [
    { value: "usd", label: "$ USD" },
    { value: "eur", label: "€ Euro" },
    { value: "jpy", label: "¥ Japanese Yen" },
    { value: "gbp", label: "£ British Pound Sterling" },
    { value: "aud", label: "$ Australian Dollar" },
    { value: "cad", label: "$ Canadian Dollar" },
    { value: "chf", label: "Fr Swiss Franc" },
    { value: "cny", label: "¥ Chinese Yuan" },
    { value: "hkd", label: "HK$ Hong Kong Dollar" },
    { value: "nzd", label: "$ New Zealand Dollar" },
    { value: "sek", label: "kr Swedish Krona" },
    { value: "krw", label: "₩ South Korean Won" },
    { value: "sgd", label: "S$ Singapore Dollar" },
    { value: "nok", label: "kr Norwegian Krone" },
    { value: "mxn", label: "$ Mexican Peso" },
    { value: "inr", label: "₹ Indian Rupee" },
    { value: "rub", label: "₽ Russian Ruble" },
    { value: "zar", label: "R South African Rand" },
    { value: "brl", label: "R$ Brazilian Real" },
    { value: "try", label: "₺ Turkish Lira" },
    { value: "idr", label: "Rp Indonesian Rupiah" },
    { value: "thb", label: "฿ Thai Baht" },
    { value: "pln", label: "zł Polish Zloty" },
    { value: "php", label: "₱ Philippine Peso" },
    { value: "czk", label: "Kč Czech Koruna" },
    { value: "myr", label: "RM Malaysian Ringgit" },
    { value: "huf", label: "Ft Hungarian Forint" },
    { value: "isk", label: "kr Icelandic Króna" },
    { value: "hrk", label: "kn Croatian Kuna" },
    { value: "dkk", label: "kr Danish Krone" },
    { value: "ils", label: "₪ Israeli Shekel" },
    { value: "ars", label: "$ Argentine Peso" },
    { value: "clp", label: "$ Chilean Peso" },
    { value: "cop", label: "$ Colombian Peso" },
    { value: "pen", label: "S/. Peruvian Sol" },
    { value: "uah", label: "₴ Ukrainian Hryvnia" },
    { value: "egp", label: "£ Egyptian Pound" },
    { value: "sar", label: "ر.س Saudi Riyal" },
    { value: "aed", label: "د.إ UAE Dirham" },
    { value: "vnd", label: "₫ Vietnamese Dong" },
    { value: "kes", label: "KSh Kenyan Shilling" },
    { value: "ngn", label: "₦ Nigerian Naira" },
    { value: "pkr", label: "₨ Pakistani Rupee" },
    { value: "ghs", label: "₵ Ghanaian Cedi" },
    { value: "ugx", label: "USh Ugandan Shilling" },
    { value: "bdt", label: "৳ Bangladeshi Taka" },
    { value: "qar", label: "ر.ق Qatari Riyal" },
    { value: "lbp", label: "ل.ل Lebanese Pound" },
    { value: "mad", label: "د.م. Moroccan Dirham" },
    { value: "cup", label: "$ Cuban Peso" },
    { value: "crc", label: "₡ Costa Rican Colón" },
    { value: "npr", label: "₨ Nepalese Rupee" },
    { value: "hnl", label: "L Honduran Lempira" },
    { value: "gtq", label: "Q Guatemalan Quetzal" },
    { value: "pab", label: "B/. Panamanian Balboa" },
    { value: "uyu", label: "$U Uruguayan Peso" },
    { value: "bob", label: "Bs. Bolivian Boliviano" },
    { value: "pyg", label: "₲ Paraguayan Guarani" },
    { value: "etb", label: "ብር Ethiopian Birr" },
    { value: "awg", label: "ƒ Aruban Florin" },
    { value: "bsd", label: "$ Bahamian Dollar" },
    { value: "bbd", label: "$ Barbadian Dollar" },
    { value: "bzd", label: "BZ$ Belize Dollar" },
    { value: "bmd", label: "$ Bermudian Dollar" },
    { value: "kyd", label: "$ Cayman Islands Dollar" },
    { value: "fjd", label: "$ Fijian Dollar" },
    { value: "gyd", label: "$ Guyanese Dollar" },
    { value: "jmd", label: "J$ Jamaican Dollar" },
    { value: "lrd", label: "$ Liberian Dollar" },
    { value: "nad", label: "$ Namibian Dollar" },
    { value: "srd", label: "$ Surinamese Dollar" },
    { value: "ttd", label: "TT$ Trinidad and Tobago Dollar" },
    { value: "xcd", label: "$ East Caribbean Dollar" },
    { value: "sbd", label: "$ Solomon Islands Dollar" }
  ];

  // Inlined rather than added to queries/agency.js (owned by another fork,
  // read-only here) - no existing hook covers GET /agency/getworkflows.
  const { data: workflowsResponse, isLoading: loader } = useQuery({
    queryKey: ["agency-workflows", agency._id],
    queryFn: async () => {
      const { response, error } = await request(GET, "/agency/getworkflows", {
        query: `agency_id=${agency._id}`,
      });
      if (error) throw error;
      return response;
    },
    enabled: !!agency._id,
  });
  // Memoized so these keep a stable reference across renders (like the old
  // state they replace) - the effect below depends on them by identity.
  const customFields = useMemo(() => (workflowsResponse?.data?.customFields || []).map((item) => ({
    ...item,
    label: item?.name,
    value: `${item?.id}-${item?.fieldKey}`,
  })), [workflowsResponse]);
  const workflows = useMemo(() => (workflowsResponse?.workflows?.workflows || []).map((item) => ({
    ...item,
    label: item?.name,
    value: `${item?.id}`,
  })), [workflowsResponse]);

  const handleToggleChange = async (event) => {
    const checked = event.target.checked;
    setToggleChecked(checked);
    setsub_accounts_subscription_fail(checked);
    await toogle_data_save({ sub_accounts_subscription_fail: checked });
  };

  const handleToggleChange1 = async (event) => {
    const checked = event.target.checked;
    setToggleChecked1(checked);
    setsub_accounts_admin_upgrade_subscription(checked);
    await toogle_data_save({ sub_accounts_admin_upgrade_subscription: checked });
  };

  const handleToggleChange2 = async (event) => {
    const checked = event.target.checked;
    setToggleChecked2(checked);
    setsub_accounts_admin_cancel_subscription(checked);
    await toogle_data_save({ sub_accounts_admin_cancel_subscription: checked });
  };

  const { mutateAsync: saveSubscriptionSetting } = useSubscriptionSetting();
  const toogle_data_save = async (updatedFields) => {
    const payload = {
      _id: agency._id,
      sub_accounts_subscription_fail,
      sub_accounts_admin_upgrade_subscription,
      sub_accounts_admin_cancel_subscription,
      ...updatedFields, // Merge the specific field to update
    };

    try {
      const { response } = await saveSubscriptionSetting(payload);
      if (response) {
        console.log("Toggle data saved successfully!");
      }
    } catch (error) {
      console.error("Error saving toggle data:", error);
    }
  };

  const [openModal, setopenModal] = useState(false)
  const [formData, setFormData] = useState([])

  const { data: categoryPricingResponse } = useCategoryPricing(agency._id);
  const pricingcat = categoryPricingResponse?.data || [];
  // Replaces the old "refetch category pricing" local loader - kept the same
  // name since savecategory/edit_request_send/delete_currency_cat below still call onLoad().
  const onLoad = () => queryClient.invalidateQueries({ queryKey: ["saas-category-pricing"] });

  const { mutateAsync: createCategoryPricing } = useCreateCategoryPricing();
  const savecategory = async () => {
    formData.agency_id = agency._id;
    const payload = formData;
    const { response } = await createCategoryPricing(payload);
    if (response) {
      setopenModal(false)
      setFormData([])
      onLoad();
    }
  }

  useEffect(() => {
    if (workflows.length && agency?.workflows) {
      setFormData({
        cancel_account: workflows?.find(item => item.value === agency?.workflows.cancel_account),
        manage_card: workflows?.find(item => item.value === agency?.workflows.manage_card),
        reset_password: workflows?.find(item => item.value === agency?.workflows.reset_password),
        added_team_member: workflows?.find(item => item.value === agency?.workflows.added_team_member),
        forgot_password: workflows?.find(item => item.value === agency?.workflows.forgot_password),
        user_password: customFields?.find(item => item.value === agency?.custom_fields?.user_password),
        saas_plan: customFields?.find(item => item.value === agency?.custom_fields?.saas_plan),
        verify_your_email: workflows?.find(item => item.value === agency?.workflows.verify_your_email)
      });
    }
  }, [workflows, agency]);

  const handleSelectChange = (selectedOption, name) => {
    setFormData({
      ...formData,
      [name]: selectedOption,
    });
  };

  const Change_of_currency = (option) => {
    setFormData({
      ...formData,
      currency: option.value
    });
  };
  const Change_of_currency_edit = (option) => {
    setEditFormData({
      ...editFormData,
      currency: option.value
    });
  };
  const [editFormData, setEditFormData] = useState({})
  const [editModalLoad, setEditModalLoad] = useState(false)
  const edit_currency_cat = (item) => {
    setEditFormData(item)
    setEditModalLoad(true)

  };
  const { mutateAsync: editCategoryPricing } = useEditCategoryPricing();
  const edit_request_send = async () => {
    const payload = editFormData
    const { response } = await editCategoryPricing(payload);
    if (response) {
      onLoad()
      setEditModalLoad(false)
    }
  }
  const { mutateAsync: deleteCategoryPricing } = useDeleteCategoryPricing();
  const delete_currency_cat = async (id) => {
    const payload = { _id: id };
    const { response } = await deleteCategoryPricing(payload);
    if (response) {
      onLoad()

    }
  }
  const { mutateAsync: updateAgency } = useUpdateAgency(true);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const workflows = {
      cancel_account: e.target.cancel_account.value,
      manage_card: e.target.manage_card.value,
      reset_password: e.target.reset_password.value,
      added_team_member: e.target.added_team_member.value,
      forgot_password: e.target.forgot_password.value,
      verify_your_email: e.target.verify_your_email.value,
    };

    const custom_fields = {
      user_password: e.target.user_password.value,
      saas_plan:e.target.saas_plan.value
    }

    const payload = {
      workflows: workflows,
      custom_fields: custom_fields,
      _id: agency._id,
    };

    const { response } = await updateAgency(payload);
    if (response) {
      Update(response.data);
    }
  };
  const handleSubmitloginWhitelabel = async (e) => {
    e.preventDefault();
    const Customization = {
      ...agency.Customization,
      signup_text: e.target.signup_text.value,
      signup_link: e.target.signup_link.value,
    }

    const payload = {
      _id: agency?._id,
      Customization: Customization,
    };

    const { response } = await updateAgency(payload);
    if (response) {
      Update(response.data);
    }
  }
  return (

    <SoftBox
      mx={0}
      py={0}
      px={0}
      variant="outlined"
      display="d-flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <div style={{ width: "100%" }}>

        <div className=' font-black font-16 padding-x d-flex justify-content-between w-100 bg-white'
          style={{ margin: "10px 0px", padding: "20px", border: "1px solid rgba(229, 229, 229, 1)", borderRadius: "10px", }}>
          <p style={{ width: "70%" }} className='font-black font-16'>Suspend sub-account when SaaS subscription fails</p>
          <p style={{ width: "30%" }} className='text-right'>
            <FormControlLabel
              control={<Switch checked={toggleChecked}
                onChange={handleToggleChange} />}
              label=""
            />
          </p>
        </div>

        <div className='font-black font-16 padding-x d-flex justify-content-between bg-white w-100'
          style={{ margin: "10px 0px", padding: "20px", border: "1px solid rgba(229, 229, 229, 1)", borderRadius: "10px", }}>
          <p style={{ width: "70%" }} className='font-black font-16'>Allow sub-account admins to upgrade their subscription.</p>
          <p style={{ width: "30%" }} className='text-right'>
            <FormControlLabel
              control={<Switch checked={toggleChecked1}
                onChange={handleToggleChange1} />}
              label=""
            />
          </p>
        </div>

        <div className='font-black font-16 padding-x d-flex justify-content-between bg-white w-100'
          style={{ margin: "10px 0px", padding: "20px", border: "1px solid rgba(229, 229, 229, 1)", borderRadius: "10px", }}>
          <p style={{ width: "70%" }} className='font-black font-16'>Allow sub-account admins to cancel their subscription.</p>
          <p style={{ width: "30%" }} className='text-right'>
            <FormControlLabel
              control={<Switch checked={toggleChecked2}
                onChange={handleToggleChange2} />}
              label=""
            />
          </p>
        </div>

        <div className='py-z-5 font-black font-16 padding-x d-flex justify-content-between bg-white w-100'
          style={{ margin: "10px 0px", padding: "20px", border: "1px solid rgba(229, 229, 229, 1)", borderRadius: "10px", }}>
          <div style={{ width: "50%" }}>
            <h2>Data Mapping</h2>
            <p>Customize the custom fields and workflows</p>
          </div>
          <div style={{ width: "50%" }}>
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: '10px' }}>Cancel Account :</p>
                <small>It will run when anyone cancel the account.</small>

                <Select
                  value={formData.cancel_account}
                  onChange={(option) => handleSelectChange(option, "cancel_account")}
                  options={workflows}
                  placeholder="Select option"
                  name="cancel_account"
                />
              </div>
              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: '10px' }}>Manage Card :</p>
                <small>It will run when anyone add Billing card.</small>
                <Select
                  value={formData.manage_card}
                  onChange={(option) => handleSelectChange(option, "manage_card")}
                  options={workflows.filter((item) => item.status !== "draft")}
                  placeholder="Select option"
                  name="manage_card"
                />
              </div>
              <div style={{ marginBottom: "20px" }}>

                <p style={{ lineHeight: '10px' }}>Reset Password :</p>
                <small>It will run when user reset his password.</small>
                <Select
                  value={formData.reset_password}
                  onChange={(option) => handleSelectChange(option, "reset_password")}
                  options={workflows.filter((item) => item.status !== "draft")}
                  placeholder="Select option"
                  name="reset_password"
                />
              </div>
              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: '10px' }}>  Add a team member :</p>
                <small>It will run when a new team member added.</small>
                <Select
                  value={formData.added_team_member}
                  onChange={(option) => handleSelectChange(option, "added_team_member")}
                  options={workflows.filter((item) => item.status !== "draft")}
                  placeholder="Select option"
                  name="added_team_member"
                />
              </div>
              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: '10px' }}>Forgotten Password :</p>
                <small>It will run when a user forgot his password.</small>
                <Select
                  value={formData.forgot_password}
                  onChange={(option) => handleSelectChange(option, "forgot_password")}
                  options={workflows.filter((item) => item.status !== "draft")}
                  placeholder="Select option"
                  name="forgot_password"
                />
              </div>
              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: '10px' }}> Which Custom field you want to store the user password</p>
                <small>It will run to store the user password.</small>
                <Select
                  value={formData.user_password}
                  onChange={(option) => handleSelectChange(option, "user_password")}
                  options={customFields?.filter((item) => item.status !== "draft")}
                  placeholder="Select option"
                  name="user_password"
                />
              </div>
              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: '10px' }}> What Workflow You want to send when the account created?</p>
                <small>This workflow will send when you account is created.</small>
                <Select
                  value={formData.verify_your_email}
                  onChange={(option) => handleSelectChange(option, "verify_your_email")}
                  options={workflows.filter((item) => item.status !== "draft")}
                  placeholder="Select option"
                  name="verify_your_email"
                />
              </div>
              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: '10px' }}> Which Custom field you want to store When Create Saas Plan</p>
                <small>It will run to store the Saas Plan.</small>
                <Select
                  value={formData.saas_plan}
                  onChange={(option) => handleSelectChange(option, "saas_plan")}
                  options={customFields?.filter((item) => item.status !== "draft")}
                  placeholder="Select option"
                  name="saas_plan"
                />
              </div>
              <button type="submit" className='savebtn-setting w-100 mt-2'> Save </button>
            </form>
          </div>
        </div>
        {/* <div className='d-flex justify-between py-z-5'>
            <div style={{ width: "50%" }}>
              <h2>Welcome Email</h2>
              <p>Customize the welcome email sent to new users.</p>
            </div>
            <div style={{ width: "50%" }}>
              <div>
                <h2> Customize your welcome email.</h2>
                <p>Customize the email that is sent to all newly added account users, with their login credentials.</p>                     </div>
              <div className=''>
                <SoftButton color={"info"}>
                  View
                </SoftButton>
                &nbsp;&nbsp;
                <SoftButton color={"success"}>
                  Customize Now
                </SoftButton>
              </div>
            </div>
          </div> */}
        <div className='py-z-5 font-black font-16 padding-x d-flex justify-content-between bg-white w-100'
          style={{ margin: "10px 0px", padding: "20px", border: "1px solid rgba(229, 229, 229, 1)", borderRadius: "10px", }}>

          <div style={{ width: "50%" }}>

            <h2>Categories</h2>
            <p>Manage plan categories</p>
          </div>
          <div style={{ width: "50%" }}>
            <div className='text-right'>
              <button className='savebtn-setting' onClick={() => setopenModal(true)} style={{ padding: "10px 20px", cursor: 'pointer' }}> + Add new
              </button>
            </div>
            {openModal &&
              <div className="modal-zz-confirm text-left"  >
                <div className="scrollable-modal-content bg-white  rounded" style={{ position: "relative" }}>
                  <h2 className='text-black text-left font-14' style={{ marginBottom: "10px" }}>Add  New Category
                  </h2>
                  <span className='crossison' onClick={() => setopenModal(false)}>X</span>
                  <input
                    type="text"
                    id="category"
                    className="form-control-agust w-full"
                    name="category"
                    placeholder={"Enter Category Name "}
                    value={formData.category}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        name: e.target.value,
                      })
                    }
                  />
                  <div style={{ margin: "10px 0px" }}>
                    <ReactSelect
                      className="form-input w-full"
                      // defaultValue={{ value: "clothing", label: "Clothing" }}
                      options={currencies}
                      isMultiple={false}
                      onChange={Change_of_currency} />
                  </div>

                  <div className='w-100 margin-top-20px'>
                    <button type='submit' className='btn-newdezine' onClick={savecategory}>Save</button>
                  </div>
                </div>
              </div>
            }
            {editModalLoad &&
              <div className="modal-zz-confirm text-left"  >

                <div className="scrollable-modal-content bg-white  rounded" style={{ position: "relative" }}>
                  <h2 className='text-black text-left font-14' style={{ margin: "10px" }}> Edit Category
                  </h2>
                  <span className='crossison' onClick={() => setEditModalLoad(false)}>X</span>


                  <input
                    type="text"
                    id="category"
                    className="form-control-agust w-full"
                    name="category"
                    placeholder={"Enter Category Name "}
                    value={editFormData.name}
                    onChange={(e) =>
                      setEditFormData({
                        ...editFormData,
                        name: e.target.value,
                      })
                    }
                  />
                  <div style={{ margin: "10px 0px" }}>

                    <ReactSelect
                      className="form-input w-full"
                      defaultValue={{ value: editFormData.currency, label: editFormData.currency }}
                      options={currencies}
                      isMultiple={false}
                      onChange={Change_of_currency_edit} />

                  </div>

                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <button
                      className='savebtn-setting'
                      style={{ margin: "10px 0px" }}
                      color="dark"
                      variant="outlined"
                      type="button" onClick={edit_request_send}>save</button>
                  </div>



                </div>
              </div>
            }

            <div className='p-5'>
              <div className="w-100">
                <div className="d-flex w-100">
                  <p className="p-20-px w-32-per text-left ">Name</p>
                  <p className="p-20-px w-32-per text-left">Currency</p>
                  <p className="p-20-px w-32-per text-left"></p>
                </div>




                {pricingcat.length > 0 && pricingcat.map((item) => (<>

                  <div className="d-flex w-100 tablebody-row" style={{ alignItems: "center" }}   >
                    <div className="p-20-px text-black text-bold text-left w-32-per"> {item.name} </div>
                    <div className="p-20-px text-black text-bold text-left w-32-per"> {item.currency} </div>
                    <div className="p-20-px text-black text-bold text-left w-32-per">
                      <b onClick={() => edit_currency_cat(item)} style={{ color: "blue", cursor: "pointer" }}>&#9998;</b>
                      <b onClick={() => delete_currency_cat(item._id)} style={{ color: "red", cursor: "pointer" }}>&#128465;</b>

                    </div>
                  </div>

                </>))}

              </div>
            </div>
          </div>
        </div>
        <div className='py-z-5 font-black font-16 padding-x d-flex justify-content-between bg-white w-100'
          style={{ margin: "10px 0px", padding: "20px", border: "1px solid rgba(229, 229, 229, 1)", borderRadius: "10px", }}>

          <div style={{ width: "50%" }}>

            <h2>Sign Up Settings</h2>
            <p>Manage your sign up page.</p>
          </div>
          {console.log('editFormDataeditFormDataeditFormData,editFormData', editFormData)}
          <div style={{ width: "50%" }}>
            <form onSubmit={handleSubmitloginWhitelabel}>
              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: '10px', marginBottom: "20px" }}>Sign up Text</p>
                <input
                  type="text"
                  id="signup_text"
                  className="form-control-agust"
                  name="signup_text"
                  placeholder={"Enter text here "}
                  value={editFormData.signup_text}
                  defaultValue={agency?.Customization?.signup_text}
                  onChange={(e) =>
                    setEditFormData({
                      ...editFormData,
                      name: e.target.value,
                    })
                  }
                />
              </div>
              <div style={{ marginBottom: "20px" }}>
                <p style={{ lineHeight: '10px', marginBottom: "20px" }}>Sign up link</p>

                <input
                  type="text"
                  id="signup_link"
                  className="form-control-agust"
                  name="signup_link"
                  placeholder={"Enter link here"}
                  value={editFormData.signup_link}
                  defaultValue={agency?.Customization?.signup_link}
                  onChange={(e) =>
                    setEditFormData({
                      ...editFormData,
                      name: e.target.value,
                    })
                  }
                />
              </div>
              <button type="submit" className='savebtn-setting w-100 mt-2'> Save </button>
            </form>
          </div>
        </div>
      </div>
    </SoftBox>
  )
}

export default SettingTab
